import axios from "axios";
import store from "../store";
// import { logout } from "../common/commonFunctions";
import jwt_decode from "jwt-decode";
import router from "../router";

function getToken() {
  let date = new Date().getTime() / 1000;
  let access = localStorage.getItem("access");
  let refresh = localStorage.getItem("refresh");
  let decode_access = jwt_decode(access);
  let decode_refresh = jwt_decode(refresh);
  if (decode_access.exp > date) {
    return access;
  } else if (decode_refresh.exp > date) {
    return refresh;
  } else {
    localStorage.removeItem("user_id");
    localStorage.removeItem("verified");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.clear();
    sessionStorage.removeItem("session");
    sessionStorage.clear();
    store.state.Auth.checkStatus = "LOGIN";
    store.state.isPrivate = false;
    store.state.Auth.flagVerified = false;
    router.push({ name: "AuthPage" });
  }
}

let CancelToken = axios.CancelToken;
let source = CancelToken.source();

const AxiosHelper = {
  errorHandler: (response) => {
    switch (response.status) {
      case 400:
        store.dispatch(
          "snackBar/showSnack",
          {
            text: response.data.message,
            color: "error",
            timeout: 4500,
          },
          { root: true }
        );
        break;
      case 401:
        store.dispatch(
          "snackBar/showSnack",
          {
            text: "Unauthorized",
            color: "error",
            timeout: 1500,
          },
          { root: true }
        );
        localStorage.removeItem("user_id");
        localStorage.removeItem("verified");
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.clear();
        sessionStorage.removeItem("session");
        sessionStorage.clear();
        router.push({ name: "AuthPage" });
        break;
      case 403:
        store.dispatch(
          "snackBar/showSnack",
          {
            text: "Forbidden Request",
            color: "error",
            timeout: 1500,
          },
          { root: true }
        );
        localStorage.removeItem("user_id");
        localStorage.removeItem("verified");
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.clear();
        sessionStorage.removeItem("session");
        sessionStorage.clear();
        router.push({ name: "AuthPage" });
        break;
      case 404:
        if (
          response.data.message != "undefined" &&
          response.data.message != null
        ) {
          store.dispatch(
            "snackBar/showSnack",
            {
              text: "Page not Found",
              color: "error",
              timeout: 1500,
            },
            { root: true }
          );
        } else {
          store.dispatch("snackBar/showSnack", {
            text: "Invalid API URL",
            color: "error",
          });
        }
        break;
      case 440:
        store.dispatch("snackBar/showSnack", {
          text: "PublicSession Expired",
          color: "error",
        });
        break;
      default:
        if (response.data.message) {
          // store.dispatch("snackBar/showSnack", {
          //   text: response.data.message,
          //   color: "error",
          //   timeout: "4500",
          // });
          console.log(response.data.message)
        } else {
          // store.dispatch("snackBar/showSnack", {
          //   text: "Something Went Wrong!",
          //   color: "error",
          // });
          console.log(response.data.message)
        }
    }
  },
};

const Axios = {
  request_GET: (
    url,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = false,
    fnFinallyBlock = null
  ) => {
    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
      headers["cancelToken"] = source.token;
    }
    // getToken();
    if (isTokenRequired) {
      // headers["token"] = authToken.getAccessToken();
      headers["Authorization"] = `Bearer ${getToken()}`;
    }

    return axios
      .get(url, {
        params: params,
        headers: headers,
        cancelToken: cancel ? source.token : "",
      })
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          response.headers.token !== undefined
        ) {
          // localStorage.setItem("token", response.headers.token);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          // Request cancelled
        } else {
          if (!error.response) {
            // Network error
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse(error.response);
            }
            AxiosHelper.errorHandler(error.response);
          }
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
  request_POST: (
    url,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = false,
    fnFinallyBlock = null
  ) => {
    var config = {};

    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
      config["cancelToken"] = source.token;
    }

    if (!cancel) {
      source = axios.CancelToken.source();
    }

    if (isTokenRequired) {
      // headers["token"] = authToken.getAccessToken();
      headers["Authorization"] = `Bearer ${getToken()}`;
    }

    config["headers"] = headers;

    axios
      .post(url, params, config)
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          typeof response.headers.token !== undefined
        ) {
          console.log("token updated");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (axios.isCancel(error)) {
          console.log("Request canceled", error);
        } else {
          if (!error.response) {
            // Network error
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse(error.response);
            }
            AxiosHelper.errorHandler(error.response);
          }
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
  request_PUT: (
    url,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = false,
    fnFinallyBlock = null
  ) => {
    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
    }
    /** COMMENTED ON 9 MAR **/
    if (!cancel) {
      source = axios.CancelToken.source();
    }
    headers["cancelToken"] = source.token;
    if (isTokenRequired) {
      console.log("");
      headers["Authorization"] = `Bearer ${getToken()}`;
    }
    axios
      .put(url, params, { headers: headers })
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          response.headers.token !== undefined
        ) {
          localStorage.setItem("token", response.headers.token);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          if (!error.response) {
            // Network error
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse(error.response);
            }

            AxiosHelper.errorHandler(error.response);
          }
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
  request_PATCH: (
    url,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = true,
    fnFinallyBlock = null
  ) => {
    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
    }

    if (!cancel) {
      source = axios.CancelToken.source();
    }
    headers["cancelToken"] = source.token;
    if (isTokenRequired) {
      // headers["token"] = authToken.getAccessToken();
      headers["Authorization"] = `Bearer ${getToken()}`;
    }

    axios
      .patch(url, params, { headers: headers })
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          response.headers.token !== undefined
        ) {
          localStorage.setItem("token", response.headers.token);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          if (!error.response) {
            // Network error
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse(error.response);
            }

            AxiosHelper.errorHandler(error.response);
          }
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
  request_DELETE: (
    url,
    data,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = true,
    fnFinallyBlock = null
  ) => {
    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
      headers["cancelToken"] = source.token;
    }
    if (isTokenRequired) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    }

    axios
      .delete(url, {
        data: data,
        params: params,
        headers: headers,
        cancelToken: cancel ? source.token : "",
      })
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          response.headers.token !== undefined
        ) {
          localStorage.setItem("token", response.headers.token);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          // Request cancelled
        } else {
          if (fnFailureResponse != null) {
            fnFailureResponse(error.response);
          }
          AxiosHelper.errorHandler(error.response);
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
  request_POST_PARAMS: (
    url,
    data,
    params,
    headers,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    cancel = true,
    isTokenRequired = false,
    fnFinallyBlock = null
  ) => {
    var config = {};

    if (cancel) {
      source.cancel();
      source = axios.CancelToken.source();
      config["cancelToken"] = source.token;
    }

    if (!cancel) {
      source = axios.CancelToken.source();
    }

    if (isTokenRequired) {
      // headers["token"] = authToken.getAccessToken();
      headers["Authorization"] = `Bearer ${getToken()}`;
    }

    config["headers"] = headers;
    config["params"] = params;

    axios
      .post(url, data, config)
      .then(function (response) {
        if (fnSuccessResponse != null) {
          fnSuccessResponse(response);
        }
        // update token
        if (
          response.headers.token !== null &&
          response.headers.token !== "" &&
          typeof response.headers.token !== undefined
        ) {
          console.log("token updated");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (axios.isCancel(error)) {
          console.log("Request canceled", error);
        } else {
          if (!error.response) {
            // Network error
          } else {
            if (fnFailureResponse != null) {
              fnFailureResponse(error.response);
            }
            AxiosHelper.errorHandler(error.response);
          }
        }
      })
      .finally(function () {
        if (fnFinallyBlock != null) {
          fnFinallyBlock();
        }
      });
  },
};

export default Axios;
